import { Reveal, Eyebrow } from "./Reveal";
import { LEVERS, IMAGES } from "../../data";
import { Check } from "lucide-react";

export const ThreeLevers = () => {
  return (
    <section id="les-3-leviers" className="relative bg-sand-warm py-24 sm:py-32" data-testid="three-levers-section">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <Reveal><Eyebrow>Le programme triptyque</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-serif font-semibold tracking-tight text-ocean text-3xl sm:text-4xl lg:text-5xl leading-[1.08]">
              Les 3 leviers d'un bien-être<br className="hidden sm:block" /> holistique réussi
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 text-base sm:text-lg text-muted2">
              Un équilibre parfait entre dynamisme physique, conscience nutritionnelle et lâcher-prise sensoriel.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-5 sm:gap-6">
          {LEVERS.map((lever, i) => (
            <Reveal key={lever.index} delay={i * 0.12}>
              <article
                className="group h-full rounded-[1.75rem] bg-white overflow-hidden border border-ocean/5 transition-all duration-500 hover:shadow-[0_28px_60px_rgba(10,34,40,0.14)] hover:-translate-y-1.5"
                data-testid={`card-lever-${lever.index}`}
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={IMAGES[lever.image]}
                    alt={lever.title}
                    className="w-full h-full object-cover transition-transform duration-[1.2s] group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ocean-dark/70 via-transparent to-transparent" />
                  <span
                    className="absolute top-4 left-4 font-serif text-lg font-semibold w-11 h-11 flex items-center justify-center rounded-full text-white backdrop-blur-md border border-white/30"
                    style={{ background: lever.accent + "cc" }}
                  >
                    {lever.index}
                  </span>
                  <span className="absolute bottom-4 left-4 text-[11px] uppercase tracking-[0.18em] font-semibold text-white/90 bg-black/25 backdrop-blur-sm rounded-full px-3 py-1.5">
                    {lever.highlight}
                  </span>
                </div>

                <div className="p-6">
                  <h3 className="font-serif text-2xl font-semibold text-ocean leading-tight">{lever.title}</h3>
                  <p className="text-sm font-medium mt-1" style={{ color: lever.accent }}>{lever.subtitle}</p>
                  <ul className="mt-5 space-y-3">
                    {lever.details.map((d, j) => (
                      <li key={j} className="flex gap-3 text-sm text-muted2 leading-relaxed">
                        <Check className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color: lever.accent }} />
                        <span>{d}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
